if (import.meta.env['VITE_STYLUX_API_BASE_URL'] === undefined) {
  throw new Error(
    'Expected import.meta.env.VITE_STYLUX_API_BASE_URL to be defined.',
  );
}

export const STYLUX_API_BASE_URL = import.meta.env['VITE_STYLUX_API_BASE_URL'];
export const STYLUX_API_GRAPHQL_ENDPOINT = `${STYLUX_API_BASE_URL}/graphql`;
